module.exports = __webpack_public_path__ + "img/honey-badger.67cbdfdc.gif";